import Icon from "@ant-design/icons";

const CustomIcon = ({ width = 16, height = 16, color = "#86BA3E" }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 16 16"
            fill="none"
        >
            <rect
                width={width}
                height={height}
                fill="white"
                fill-opacity="0.01"
            />
            <path
                d="M6.5 12L2 7.50003L2.707 6.79303L6.5 10.5855L13.293 3.79303L14 4.50003L6.5 12Z"
                fill={color}
            />
        </svg>
    );
};

export const ApproveIcon = (props) => (
    <Icon component={CustomIcon} {...props} />
);
